<section id="dynamic-category-filter-123452" class="style-dynamic-category-filter-123452 editable">
    @if (availableFilterAttributes()?.length) {
    <div class="category-page-filter desktop-filter-layout-container filter-layout-background filter-layout-border-color filter-layout-border-top-left-radius filter-layout-border-top-right-radius filter-layout-border-bottom-left-radius filter-layout-border-bottom-right-radius">
        <div class="filter-wrapper">
            @if (category()) {
            <div class="filter-label filter-heading-text-size filter-heading-text-color filter-heading-text-font-weight filter-heading-text-transform">
                {{ category() | titlecase }}
            </div>
            }

            <div class="filter">
                @for (availableAttribute of availableFilterAttributes(); track $index; let i = $index) {
                <div class="drop-down">
                    <div class="drop-down-placeholder category-filter-drop-down-border-color category-filter-drop-down-border-top-left-radius category-filter-drop-down-border-top-right-radius category-filter-drop-down-border-bottom-left-radius category-filter-drop-down-border-bottom-right-radius category-filter-drop-down-background">
                        <h2 class="facet-label-text-size facet-label-text-color facet-label-text-font-weight facet-label-text-transform">
                            {{ availableAttribute?.label }}
                        </h2>

                        <div class="facet-arrow-up facet-arrow-up-color"></div>
                        <div class="facet-arrow-down facet-arrow-down-color"></div>
                    </div>
                    <div class="drop-down-content filter-option-background-color">
                        <ul>
                            @for (filter of availableAttribute?.filters; track filter.value + '_' + $index) {
                            <li>
                                <label class="filter-option-value">
                                    <div class="check-mark-container check-box-background check-mark-border-color check-box-border-top-left-radius check-box-border-top-right-radius check-box-border-bottom-left-radius check-box-border-bottom-right-radius" [ngClass]="{
                      'filter-option-border-color-active filter-option-background-active':
                        filter.checked
                    }">
                                        @if (filter.checked) {
                                        <span class="check-mark-icon check-mark-icon-color" [ngClass]="{
                        'check-mark-icon-color-active': filter.checked
                      }">&check;</span>
                                        }
                                    </div>
                                    <div class="filter-option-text-size filter-option-text-color filter-option-value-border-color filter-option-font-weight filter-option-text-transform">
                                        {{ filter?.value }}
                                        <span class="filter-count"> ({{ filter.doc_count }})</span>
                                    </div>
                                    <input class="filter-option-checkbox check-box-background check-box-hover-color" type="checkbox" [value]="filter?.value" [checked]="filter.checked" (click)="updateFilter(filter, availableFilterAttributes())" />
                                </label>
                            </li>
                            }
                        </ul>
                    </div>
                </div>
                }
            </div>
        </div>

        @if (currentAppliedFilters()?.length) {
        <div class="selected-filters-container">
            <button class="clear-btn filter-clear-btn-text-size filter-clear-btn-text-color filter-clear-btn-text-font-weight filter-clear-btn-text-transform" (click)="resetAllFilters(availableFilterAttributes())">
                Clear All
            </button>
            <ul class="selected-wrapper">
                @for (currentAppliedFilter of currentAppliedFilters(); track
                currentAppliedFilter.filter?.value + '_' + $index) {
                <li class="filter-chip-border-color filter-chip-background chip-border-top-left-radius chip-border-top-right-radius chip-border-bottom-left-radius chip-border-bottom-right-radius">
                    <div class="filter-chip-text-size filter-chip-text-color filter-chip-text-font-weight filter-chip-text-transform" [title]="currentAppliedFilter?.filter?.value">
                        {{ currentAppliedFilter?.filter?.value }}

                        <span class="filter-count"> ({{ currentAppliedFilter?.filter?.doc_count }}) </span>
                    </div>

                    <div class="clear-icon filter-chip-text-color" (click)="updateFilter(currentAppliedFilter.filter, availableFilterAttributes())">
                        &times;
                    </div>
                </li>
                }
            </ul>
        </div>
        }
    </div>
    }

    <div class="mobile-filter-layout-container filter-layout-background filter-layout-border-color filter-layout-border-top-left-radius filter-layout-border-top-right-radius filter-layout-border-bottom-left-radius filter-layout-border-bottom-right-radius" (click)="selectFilter(-1)">
        <div class="filter-wrapper">
            <div class="heading">
                @if (category()) {
                <div class="filter-label filter-heading-text-size filter-heading-text-color filter-heading-text-font-weight filter-heading-text-transform">
                    {{ category() | titlecase }}
                </div>
                } @if (currentAppliedFilters()?.length) {
                <button class="clear-btn filter-clear-btn-text-size filter-clear-btn-text-color filter-clear-btn-text-font-weight filter-clear-btn-text-transform" (click)="resetAllFilters(availableFilterAttributes())">
                    Clear All
                </button>
                }
            </div>

            @if (currentAppliedFilters()?.length) {
            <div class="selected-filters-container">
                <ul class="selected-wrapper">
                    @for (currentAppliedFilter of currentAppliedFilters(); track
                    currentAppliedFilter.filter?.value + '_' + $index) {
                    <li class="filter-chip-border-color filter-chip-background chip-border-top-left-radius chip-border-top-right-radius chip-border-bottom-left-radius chip-border-bottom-right-radius">
                        <div class="filter-chip-text-size filter-chip-text-color filter-chip-text-font-weight filter-chip-text-transform" [title]="currentAppliedFilter?.filter?.value">
                            {{ currentAppliedFilter?.filter?.value }}

                            <span class="filter-count"> ({{ currentAppliedFilter?.filter?.doc_count }}) </span>
                        </div>

                        <div class="clear-icon filter-chip-text-color" (click)="updateFilter(currentAppliedFilter.filter, availableFilterAttributes())">
                            &times;
                        </div>
                    </li>
                    }
                </ul>
            </div>
            } @for (availableAttribute of availableFilterAttributes(); track $index; let i = $index) {
            <div class="drop-down">
                <div class="drop-down-placeholder category-filter-drop-down-border-color category-filter-drop-down-border-top-left-radius category-filter-drop-down-border-top-right-radius category-filter-drop-down-border-bottom-left-radius category-filter-drop-down-border-bottom-right-radius category-filter-drop-down-background" [ngClass]="{ 'dropdown-active': i === selectedFilterSignal() }" (click)="$event.stopPropagation(); selectFilter(i)">
                    <h2 class="facet-label-text-size facet-label-text-color facet-label-text-font-weight facet-label-text-transform">
                        {{ availableAttribute?.label }}
                    </h2>

                    <div class="facet-arrow-up facet-arrow-up-color"></div>
                    <div class="facet-arrow-down facet-arrow-down-color"></div>
                </div>
                @if (i === selectedFilterSignal()) {
                <div class="drop-down-content filter-option-background-color" [ngClass]="{ 'drop-down-active': i === selectedFilterSignal() }">
                    <ul>
                        @for (filter of availableAttribute?.filters; track filter.value + '_' + $index) {
                        <li (click)="$event.stopPropagation()">
                            <label class="filter-option-value">
                                <div class="check-mark-container check-box-background check-mark-border-color check-box-border-top-left-radius check-box-border-top-right-radius check-box-border-bottom-left-radius check-box-border-bottom-right-radius" [ngClass]="{
                    'filter-option-border-color-active filter-option-background-active':
                      filter.checked
                  }">
                                    @if (filter.checked) {
                                    <span class="check-mark-icon check-mark-icon-color" [ngClass]="{
                      'check-mark-icon-color-active': filter.checked
                    }">&check;</span>
                                    }
                                </div>
                                <div class="filter-option-text-size filter-option-text-color filter-option-value-border-color filter-option-font-weight filter-option-text-transform">
                                    {{ filter?.value }}
                                    <span class="filter-count">({{ filter.doc_count }})</span>
                                </div>
                                <input class="filter-option-checkbox check-box-background check-box-hover-color" type="checkbox" [value]="filter?.value" [checked]="filter.checked" (change)="updateFilter(filter, availableFilterAttributes())" />
                            </label>
                        </li>
                        }
                    </ul>
                </div>
                }
            </div>
            }
        </div>
    </div>
</section>